import React from 'react';
import { useSelector } from 'react-redux';

const OrderSummary = () => {
	const { detail } = useSelector((store) => store?.order);

	const items = detail?.request_post_datas?.items || [];

	return (
		<>
			<div className='border-t-1 border-solid border-gray-200' />
			<p className='text-xs text-gray-500 font-normal pt-4'>Ringkasan Pesanan</p>
			<ul className='pt-2'>
				{items?.map((item, index) => (
					<li key={index} className='pt-2'>
						<div className='flex justify-between items-start'>
							<p className='text-xs text-gray-900 font-semibold'>{item?.itemName}</p>
							<p className='text-xs text-gray-900 font-semibold'>{item?.itemQuantity}x</p>
						</div>
						{item?.comboset?.map?.((comboItem, comboIndex) => (
							<div key={comboIndex} className='mt-2 text-xxs text-gray-700'>
								<p className='font-semibold text-gray-800'>{comboItem?.comboSetname}</p>
								<p className='mt-1 text-gray-600'>
									{comboItem?.productDetails?.map?.((comboPro, comboProIndex) => (
										<span key={comboProIndex}>
											{comboPro.productName}
											{parseInt(comboPro.quantity) > 0 && <b> x{comboPro.quantity}</b>}
										</span>
									))}
								</p>
							</div>
						))}
						{item.itemNote && (
							<div className='mt-2 text-xxs text-gray-800 bg-gray-100 p-2 rounded-md'>
								<span className='font-medium'>Catatan :</span>
								<p className='mt-1 text-gray-600'>{item.itemNote}</p>
							</div>
						)}
					</li>
				))}
			</ul>
      <div className='border-b-1 border-solid border-gray-200 mt-5' />
		</>
	);
};

export default OrderSummary;
